import React, { useState, useEffect } from 'react';
import { WhatsAppOutlined, CloseOutlined } from '@ant-design/icons';
import './WhatsAppSupport.css';

const WhatsAppSupport = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [message, setMessage] = useState('');
  const [showCursor, setShowCursor] = useState(false);
  const phoneNumber = '+255738867270';

  useEffect(() => {
    if (isExpanded) {
      // Start the typing animation when expanded
      const timer = setTimeout(() => {
        setMessage('Hello BeyondSchools');
        setShowCursor(true);
      }, 300);
      
      return () => clearTimeout(timer);
    } else {
      // Reset when collapsed
      setMessage('');
      setShowCursor(false);
    }
  }, [isExpanded]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalMessage = message.trim() || 'Hello BeyondSchools';
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(finalMessage)}`, '_blank');
  };

  return (
    <div className={`whatsapp-support ${isExpanded ? 'expanded' : ''}`}>
      {isExpanded && (
        <div className="whatsapp-form">
          <div className="form-header">
            <h4>Chat with Support</h4>
            <button 
              className="close-btn" 
              onClick={() => setIsExpanded(false)}
              aria-label="Close chat"
            >
              <CloseOutlined />
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="textarea-container">
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message here..."
                rows="4"
              />
              {showCursor && message === 'Hello BeyondSchools' && (
                <span className="typing-cursor">|</span>
              )}
            </div>
            <button type="submit" className="send-button">
              Send via WhatsApp
            </button>
          </form>
        </div>
      )}
      <button 
        className="whatsapp-button"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label="WhatsApp support"
      >
        <WhatsAppOutlined className="whatsapp-icon" />
      </button>
    </div>
  );
};

export default WhatsAppSupport;